import { render, staticRenderFns } from "./dataDriven.vue?vue&type=template&id=37dcda17&scoped=true&"
import script from "./dataDriven.vue?vue&type=script&lang=js&"
export * from "./dataDriven.vue?vue&type=script&lang=js&"
import style0 from "./dataDriven.vue?vue&type=style&index=0&id=37dcda17&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dcda17",
  null
  
)

export default component.exports